// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","buttonsContainer":"_13jC","content":"_2DgJ","illustration":"_3xrc"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Auth/Login/Login.scss
// module id = U3V0
// module chunks = 0